module.exports = __webpack_public_path__ + "static/media/iosevka-ss08-bold.9a2fd072.woff";